export const DISTRICT_INDEX = 0;
export const COORDINATE_INDEX = 1;
export const COUNTRY_NAME_INDEX = 2;
export const COUNTRY_CODE_INDEX = 3;
export const SUBSCRIPTION_NUMBERS_INDEX = 4;
export const USER_EMAIL_INDEX = 5;

export type activeMarketsArrayType = [string, string, string, string, number, string];

export interface DataTableRowTypes  {
    id: number;
    district: string;
    countryName: string;
    countryCode: string;
    subscriptionNumber: number;
    email: string;
  }
  